<template>
  <div>
    <div class="d-flex align-items-center" v-if="positionsLoading">
      <b-spinner small class="mx-2"></b-spinner>Wczytuje...
    </div>
    <div v-if="positionsLoading === false">
      <ConstructionSubcontractorsSelect
        :withphone="true"
        :position="availablePositions[0]"
        :index="0"
        :selected="this.selected[0]"
        @update="updateSubcontractor"
      />
      <ConstructionSubcontractorsSelect
        :withphone="true"
        :position="availablePositions[1]"
        :index="1"
        :selected="this.selected[1]"
        @update="updateSubcontractor"
      />
      <ConstructionSubcontractorsSelect
        :withphone="true"
        :position="availablePositions[2]"
        :index="2"
        :selected="this.selected[2]"
        @update="updateSubcontractor"
      />
      <ConstructionSubcontractorsSelect
        :withphone="true"
        :position="availablePositions[3]"
        :index="3"
        :selected="this.selected[3]"
        @update="updateSubcontractor"
      />
      <ConstructionSubcontractorsSelect
        :withphone="true"
        :position="availablePositions[4]"
        :index="4"
        :selected="this.selected[4]"
        @update="updateSubcontractor"
      />
      <ConstructionSubcontractorsSelect
        :withphone="true"
        :position="availablePositions[4]"
        :index="5"
        :selected="this.selected[5]"
        @update="updateSubcontractor"
      />
      <ConstructionSubcontractorsSelect
        :withphone="true"
        :position="availablePositions[4]"
        :index="6"
        :selected="this.selected[6]"
        @update="updateSubcontractor"
      />
      <ConstructionSubcontractorsSelect
        :withphone="true"
        :position="availablePositions[4]"
        :index="7"
        :selected="this.selected[7]"
        @update="updateSubcontractor"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ConstructionSubcontractorsSelect from "@/components/construction/ConstructionSubcontractorsSelect";

export default {
  name: "ConstructionSubcontractorsSelectsForm",
  components: { ConstructionSubcontractorsSelect },
  props: {
    subcontractors: {
      type: Array,
    },
  },
  data() {
    return {
      positionsLoading: true,
      selected: [
        {
          position_id: 1,
          user_id: null,
        },
        {
          position_id: 2,
          user_id: null,
        },
        {
          position_id: 3,
          user_id: null,
        },
        {
          position_id: 4,
          user_id: null,
        },
        {
          position_id: 5,
          user_id: null,
        },
        {
          position_id: 5,
          user_id: null,
        },
        {
          position_id: 5,
          user_id: null,
        },
        {
          position_id: 5,
          user_id: null,
        },
      ],
    };
  },
  computed: {
    ...mapGetters("app", ["availablePositions"]),
  },
  created() {
    if (this.getRole !== "subcontractor") {
      this.loadAvailablePositions().then(() => {
        this.positionsLoading = false;
      });

      if (this.subcontractors.length > 0) {
        this.$_.each(this.subcontractors, (item) => {
          let that = this.$_.find(this.selected, {
            position_id: item.position_id,
            user_id: null,
          });
          if (that) {
            that.user_id = item.user_id;
            that.firstname = item.firstname;
            that.lastname = item.lastname;
            that.phone = item.phone;
          }
        });
      }
    }
  },
  methods: {
    ...mapActions("app", ["loadAvailablePositions"]),
    updateSubcontractor(positionsub, newUserId) {
      positionsub.user_id = newUserId;
      this.$emit("onchange", this.selected);
    },
  },
};
</script>
